import submitCommand from '../../../services/submitCommand';
import { Step } from '../../steps/models/course';

export const removeFeedbackResponseUser = (courseId: string, task: Step, email: string, initiatingUserId: string) => {
  const cmd = {
    id: courseId,
    taskInstance: task,
    email: email,
    initiatingUserId: initiatingUserId,
  };

  return submitCommand(
    courseId,
    cmd,
    'RemoveFeedbackResponseUser',
    'FeedbackResponseUserRemoved',
    'TaskListInstanceError'
  );
};
